exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".locale-switcher-option-label {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.locale-switcher-option-label img {\n  margin-right: 0.5em;\n}\n", ""]);
